import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { EmployeeApiObject } from '@qaroni-app/employee/types/employee-response';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import {
  CheckListsActivitiesCreateDto,
  ChecklistsActivitiesResponse,
  ChecklistsActivitiesUpdateDto,
} from '../types/checklists-activities';

@Injectable({
  providedIn: 'root',
})
export class ChecklistsActivitiesHttpService {
  private http = inject(HttpClient);

  public list$(companyID: number, checklistID: number, params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checklists/${checklistID}/activities`;

    return this.http.get<ChecklistsActivitiesResponse>(url, { params });
  }

  public get$(companyID: number, checklistID: number, activityID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checklists/${checklistID}/activities/${activityID}`;

    return this.http.get<ChecklistsActivitiesResponse>(url);
  }

  public create$(
    companyID: number,
    checklistID: number,
    activity: CheckListsActivitiesCreateDto
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checklists/${checklistID}/activities`;

    return this.http.post<ChecklistsActivitiesResponse>(url, activity);
  }

  public update$(
    companyID: number,
    checklistID: number,
    activityID: number,
    activity: ChecklistsActivitiesUpdateDto
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checklists/${checklistID}/activities/${activityID}`;

    return this.http.patch<ChecklistsActivitiesResponse>(url, activity);
  }

  public delete$(companyID: number, checklistID: number, activityID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checklists/${checklistID}/activities/${activityID}`;

    return this.http.delete<ChecklistsActivitiesResponse>(url, {
      observe: 'response',
    });
  }

  public getEmployeeActivities$(
    companyID: number,
    checklistID: number,
    activityID: number,
    params?: Params
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checklists/${checklistID}/activities/${activityID}/employees`;

    return this.http.get<EmployeeApiObject>(url, { params });
  }

  public deleteFile$(
    companyID: number,
    checklistID: number,
    activityID: number,
    fileID: number
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/checklists/${checklistID}/activities/${activityID}/files/${fileID}`;

    return this.http.delete<ChecklistsActivitiesResponse>(url, {
      observe: 'response',
    });
  }
}
